import { render } from "./TherapyDashboard.vue?vue&type=template&id=e0b89dde&scoped=true"
import script from "./TherapyDashboard.vue?vue&type=script&lang=js"
export * from "./TherapyDashboard.vue?vue&type=script&lang=js"

import "./TherapyDashboard.vue?vue&type=style&index=0&id=e0b89dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b89dde"]])

export default __exports__